import React from "react";
import { Container, Row } from "reactstrap";
import OpenJobsReport from "../OpenJobsReports";
import UtilizationReport from "../UtilizationReports";
import PipelineReport from "../PipeLineReport";
import PipelineCompareReport from "../PipelineCompareReport";
import BookedContractedReport from "../BookedContractedReport";
import SalesTeamLeaderboard from "../SalesTeamLeaderboard";
import Header from "../../../../../Layout/Header/Header";
import ClientPerformanceReport from "../ClientPerformanceReport";
import RecruiterPerformanceReport from "../RecruiterPerformanceReport";
import LegalDocRequestReport from "../LegalDocRequestReport";
import AssetRequestsReport from "../AssetRequestsReport";

interface ReportWizardContainerProps {
  reportType:
    | "openJobs"
    | "utilization"
    | "pipeline"
    | "pipeline-compare"
    | "bookedContracted"
    | "leaderboard"
    | "clientPerformance"
    | "recruiterPerformance"
    | "legalDocRequests"
    | "assetRequestStatus";
  filterStatus?: string;
  reportTitle?: string;
}

const ReportWizardContainer: React.FC<ReportWizardContainerProps> = ({
  reportType,
  filterStatus,
  reportTitle,
}) => {
  console.log("ReportWizard:", reportType, filterStatus);

  const renderReport = () => {
    switch (reportType) {
      case "openJobs":
        return (
          <OpenJobsReport
            filterStatus={filterStatus}
            reportTitle={reportTitle}
          />
        );
      case "utilization":
        return <UtilizationReport />;
      case "bookedContracted":
        return <BookedContractedReport />;
      case "pipeline":
        return <PipelineReport />;
      case "pipeline-compare":
        return <PipelineCompareReport />;
      case "leaderboard":
        return <SalesTeamLeaderboard />;
      case "clientPerformance":
        return <ClientPerformanceReport />;
      case "recruiterPerformance":
        return <RecruiterPerformanceReport />;
      case "legalDocRequests":
        return <LegalDocRequestReport />;
      case "assetRequestStatus":
        return <AssetRequestsReport />;
      default:
        return <div>Invalid report type specified.</div>;
    }
  };

  return (
    <>
      <Container fluid>
        <Header />
        <Row>{renderReport()}</Row>
      </Container>
    </>
  );
};

export default ReportWizardContainer;
